import { Maybe } from 'graphql/jsutils/Maybe'
import React, { useMemo } from 'react'
import { Grid, Typography, Box, Switch } from '@mui/material'
import ListSelectMenu from '../ListSelectMenu'

export type GlobalSettingsOptionsProps = {
  cohortOptions: string[]
  subgroupOptions: string[]
  cohort?: Maybe<string>
  subgroup?: Maybe<string>
  pastResults?: Maybe<boolean>
  onChangeCohort?: (cohort: string) => any
  onChangeSubgroup?: (subgroup: string) => any
  onChangePastResults?: (pastResults: boolean) => any
}

const GlobalSettingsOptions: React.FC<GlobalSettingsOptionsProps> = ({
  cohortOptions,
  subgroupOptions,
  cohort,
  subgroup,
  pastResults,
  onChangeCohort = () => {},
  onChangeSubgroup = () => {},
  onChangePastResults = () => {},
}) => {
  const cohorts = useMemo(
    () => cohortOptions.map((c) => ({ id: c, title: c })),
    [cohortOptions]
  )
  const subgroups = useMemo(
    () => subgroupOptions.map((c) => ({ id: c, title: c })),
    [subgroupOptions]
  )

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography component="p" gutterBottom>
          <strong>Cohort</strong>
        </Typography>
        <ListSelectMenu
          options={cohorts}
          isOptionSelected={(option) => option.id === cohort}
          onSelectOption={(option) => onChangeCohort(option.id)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography component="p" gutterBottom>
          <strong>Subgroup</strong>
        </Typography>
        <ListSelectMenu
          options={subgroups}
          isOptionSelected={(option) => option.id === subgroup}
          onSelectOption={(option) => onChangeSubgroup(option.id)}
        />
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1,
            px: 2,
            border: 1,
            borderColor: 'grey.400',
          }}
        >
          <Typography component="label">
            <strong>Past Results</strong>
          </Typography>
          <Switch
            checked={!!pastResults}
            onChange={(e, val) => onChangePastResults(val)}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default GlobalSettingsOptions
